import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppGlobals } from '../../../../app.global';
import { tokendata } from '../../variable';
import { AuthService } from '../../../../service/auth.service';
import { ExcelService } from '../../../../service/excel.service';
import { TypesUtilsService } from '../../../../core/_base/crud';

export interface PeriodicElement {
    category: string;
    id: number;
    created_on: String;
    service: string;
    assigned: string;
    amount: number;
    type: string;
    status: string;
    action: string;
    hide_bids: String;
}
const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
    selector: 'kt-order-listing',
    templateUrl: './order-listing.component.html',
    styleUrls: ['./order-listing.component.scss']
})
export class OrderListingComponent implements OnInit {
    displayedColumns: string[] = ['order_id', 'created_on', 'country', 'category', 'service', 'assigned', 'awarded_on', 'amount', 'type', 'status', 'action'];
    dataSource: any;
    @ViewChild(MatPaginator, { static: true, }) paginator: MatPaginator;

    all_records = [];
    excel_record = []
    check_sess = '';
    perm = [];
    search: string = '';
    country = '';
    pageLength = 0;
    pageIndex = 0;
    pageSize = 25;
    start = '';
    end = '';
    accept_start = '';
    accept_end = '';

    constructor(private router: Router,
        private baseUrl: AppGlobals,
        private auth: AuthService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private ref: ChangeDetectorRef,
        private excelService: ExcelService,
        private typesUtilsService: TypesUtilsService) { }

    ngOnInit() {
        if (localStorage.getItem('tocmadmin_adminPerm') != '' && localStorage.getItem('tocmadmin_adminPerm') != null) {
            let aa = localStorage.getItem('tocmadmin_adminPerm');
            var perm = aa.split(',');
            if (perm.includes('13') == false)
                this.router.navigate(['/dashboard']);
        }
        this.check_sess = localStorage.getItem('tocmadmin_token');
        if (this.check_sess == null || this.check_sess == "") {
            this.router.navigate(['/auth/main-login']);
        }
        this.search = '';
        this.searchStatus();

        // document.getElementById("page_loader").style.display = "block";
        // this.auth.commongetSrvs(this.baseUrl.baseAppUrl + 'admin/orderlisting_listing').subscribe((res: tokendata) => {
        //   document.getElementById("page_loader").style.display = "none";
        //   console.log(res);
        //   if (res.status == '1') {

        //     let j = 1;
        //     for (let i = 0; i < res.data.length; i++) {
        //       this.all_records.push({ id: res.data[i].id, created_on: this.getDate(res.data[i].created_on), order_id: res.data[i].id, category: res.data[i].cat_name, service: res.data[i].sub_name, assigned: res.data[i].tech, amount: res.data[i].booking_amount, type: res.data[i].type, status: res.data[i].booking_status, action: '' },);
        //       j++;
        //       //res.data[i].post_number
        //     }
        //     //console.log(this.all_records);
        //     this.dataSource = new MatTableDataSource<PeriodicElement>(this.all_records);
        //     this.dataSource.paginator = this.paginator;
        //   }
        //   else {
        //     this.dataSource = new MatTableDataSource<PeriodicElement>(this.all_records);
        //     this.dataSource.paginator = this.paginator;
        //     //this.error_msg = res.message;
        //   }
        //   this.ref.detectChanges();
        // });

    }

    orgValueChange() {
        this.searchStatus();
    }

    onCountryChange(evt) {
        this.country = evt.value;
        this.searchStatus();
    }


    searchStatus() {
        //commongetSrvs
        document.getElementById("export_loader").style.display = "none";
        document.getElementById("page_loader").style.display = "block";
        this.auth.commongetSrvs(this.baseUrl.baseAppUrl + 'admin/orderlisting_listing?start=' + this.start + '&end=' + this.end + '&accept_start=' + this.accept_start + '&accept_end=' + this.accept_end + '&page_index=' + this.pageIndex + '&page_size=' + this.pageSize + '&search=' + this.search + '&country=' + this.country).subscribe((res: tokendata) => {
            document.getElementById("page_loader").style.display = "none";
            console.log(res);
            this.all_records = [];
            if (res.status == '1') {
                this.pageLength = res.count;
                let j = 1;
                for (let i = 0; i < res.data.length; i++) {
                    console.log(res.data[i].updated_on);
                    var awarded_on = '';
                    console.log(this.typesUtilsService.getDateFormatterFromString(res.data[i].updated_on));
                    if (res.data[i].awarded_on == null || res.data[i].awarded_on == "" || res.data[i].awarded_on == "0000-00-00 00:00:00") {
                        awarded_on = this.typesUtilsService.getUTCDateFromString(res.data[i].updated_on + "");
                    } else {
                        awarded_on = this.typesUtilsService.getUTCDateFromString(res.data[i].awarded_on + "");
                    }
                    var created_on = this.typesUtilsService.getUTCDateFromString(res.data[i].created_on + "");
                    this.all_records.push({ id: res.data[i].id, country: res.data[i].country, currency: res.data[i].currency,  created_on: created_on, order_id: res.data[i].id, category: res.data[i].cat_name, service: res.data[i].sub_name, hide_bids: res.data[i].hide_bids, assigned: res.data[i].tech, awarded_on: awarded_on, amount: res.data[i].booking_amount, type: res.data[i].type, status: res.data[i].booking_status, action: '' },);
                    j++;
                    //res.data[i].post_number
                }
                //console.log(this.all_records);
                this.dataSource = new MatTableDataSource<PeriodicElement>(this.all_records);
                this.paginator.pageIndex = this.pageIndex;
                this.paginator.pageSize = this.pageSize;
                this.paginator.length = this.pageLength;

            }
            else {
                this.dataSource = new MatTableDataSource<PeriodicElement>(this.all_records);
                this.dataSource.paginator = this.paginator;
                //this.error_msg = res.message;
            }
            this.ref.detectChanges();
        });
    }

    exportAsXLSX(): void {
        document.getElementById("export_loader").style.display = "block";
        this.auth.commongetSrvs(this.baseUrl.baseAppUrl + 'admin/orderlisting_listing?start=' + this.start + '&end=' + this.end + '&accept_start=' + this.accept_start + '&accept_end=' + this.accept_end + '&export=1&search=' + this.search).subscribe((res: tokendata) => {
            document.getElementById("export_loader").style.display = "none";
            this.excel_record = [];
            if (res.status == '1') {
                let j = 1;
                for (let i = 0; i < res.data.length; i++) {
                    var awarded_on = '';
                    if (res.data[i].awarded_on == null || res.data[i].awarded_on == "") {
                        awarded_on = this.getDate(res.data[i].updated_on);
                    } else {
                        awarded_on = this.getDate(res.data[i].awarded_on);
                    }
                    this.excel_record.push({ id: res.data[i].id, "Publish Date": this.getDate(res.data[i].created_on), "Order ID": res.data[i].id,  "Country": res.data[i].country, "Category Name": res.data[i].cat_name, "SubCategory": res.data[i].sub_name, "Assigned To": res.data[i].tech, "Award Acceptance Date": awarded_on, Amount: res.data[i].currency + " " + res.data[i].booking_amount, Type: res.data[i].type, Status: res.data[i].booking_status },);
                    j++;
                }
                if (this.excel_record.length > 0) {
                    this.excelService.exportAsExcelFile(this.excel_record, 'working_order_list');
                }
            }
        });
    }

    public doFilter = (value: string) => {
        // this.dataSource.filter = value.trim().toLocaleLowerCase();
        this.search = value.trim().toLocaleLowerCase();
        this.pageIndex = 0;
        this.searchStatus();
    }

    gotodetail(id) {
        localStorage.setItem('tocmadmin_orderId', id);
        let naviagtionExtras: NavigationExtras = {
            queryParams: {
                tocmadmin_orderId: id,
            }
        }
        this.router.navigate(['/order-detail'], naviagtionExtras);
    }

    getDate(date) {
        try {
            return date.substring(0, 10) + " " + date.substring(11, 16);
        } catch (err) {
            console.log(err);
            return '';
        }
    }

    getServerData(event?: PageEvent) {
        console.log(event.pageIndex);
        console.log(event.pageSize);

        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.searchStatus();
    }
}


export class displayedColumns { }